import Vue from 'vue'
import Vuex from 'vuex'
// // import * as firebase from 'firebase'
// import firebase from 'firebase/app';
// import 'firebase/auth';
// import 'firebase/database';
// ///import { FirebaseAuth } from '../../../node_modules/@firebase/auth-types';

Vue.use(Vuex)

export default{
    state: { 
        MALAWI:null,
        ALL_DISTRICTS:null,
        DISTRICTS:null,
        CONSTITUENCIES:null,
        WARDS:null,
        CENTRES:null,

    },
    //___________________-GETTERS-_________________
    getters: { 
      getMalawiGeoJson(state) {
        return state.MALAWI
      }, 
      getAllDistrictsGeoJson(state) {
        return state.ALL_DISTRICTS
      }, 
      getDistrictsGeoJson(state) {
        return state.DISTRICTS
      }, 
      getConstituenciesGeoJson(state) {
        return state.CONSTITUENCIES
      } 
       
    },
    //___________________-MUTATIONS-___________________
    mutations:{  
      updateMalawi(state, payload) {
        state.malawi = payload
      },    
    },
    //____________________-ACTIONS-_____________________
    actions: { 
      //-------------[SETTER]---------------
      setMalawi({ commit,state}, payload) { 
        commit('updateMalawi', payload)
      },  
      loadAllDistricts({commit,state},payload){
        let http = this._vm.$http
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: true,
          name: 'loading/allDistrict'
        }) 
        http.get("/json/all.json")
        .then(res=>{
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'loading/allDistrict'
          }) 
          commit('updateResponses', {
            res: 'loading/allDistrict/successful',
            val: res
          })
          state.ALL_DISTRICTS = res.body
        })
        .catch(err=>{
          commit('updateResponses', {
            res: 'loading/allDistrict/error',
            val: err
          })
        })
      },
      loadMalawi({commit,state},payload){
        let http = this._vm.$http
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: true,
          name: 'loading/malawi'
        }) 
        http.get("/json/malawi.geojson")
        .then(res=>{
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'loading/malawi'
          }) 
          commit('updateResponses', {
            res: 'loading/malawi/successful',
            val: res
          })
          state.MALAWI = res.body
        })
        .catch(err=>{
          commit('updateResponses', {
            res: 'loading/malawi/error',
            val: err
          })
        })
      },
      loadDistricts({commit,state},payload){
        let http = this._vm.$http
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: true,
          name: 'loading/districts'
        }) 
        http.get("/json/districts.geojson")
        .then(res=>{
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'loading/districts'
          }) 
          commit('updateResponses', {
            res: 'loading/districts/successful',
            val: res
          })
          state.DISTRICTS = res.body
        })
        .catch(err=>{
          commit('updateResponses', {
            res: 'loading/districts/error',
            val: err
          })
        })
      },
      loadConstituencies({commit,state},payload){
        let http = this._vm.$http
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: true,
          name: 'loading/constituencies'
        }) 
        http.get("/json/constituencies.geojson")
        .then(res=>{
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'loading/constituencies'
          }) 
          commit('updateResponses', {
            res: 'loading/constituencies/successful',
            val: res
          })
          state.CONSTITUENCIES = res.body
        })
        .catch(err=>{
          commit('updateResponses', {
            res: 'loading/constituencies/error',
            val: err
          })
        })
      }
    }
}